import { Lightning, Colors } from "@lightningjs/sdk";
import theme from "../../../../lib/theme";

const PADDING_X = 28;
export const CATEGORY_ITEM_H = 65;
export const CATEGORY_ITEM_W = 219;

interface CategoryItemSpec extends Lightning.Component.TemplateSpec {
    Bg: object;
    Label: object;
    FocusLine: object;
}

export class CategoryItem
    extends Lightning.Component<CategoryItemSpec>
    implements Lightning.Component.ImplementTemplateSpec<CategoryItemSpec>
{
    private _name = "";
    private _selected = false;
    private _isFocused = false;

    static override _template(): Lightning.Component.Template<CategoryItemSpec> {
        return {
            h: CATEGORY_ITEM_H,
            Bg: {
                w: (w) => w,
                h: CATEGORY_ITEM_H,
                rect: true,
                color: Colors(theme.colors.bg.light).get(),
                shader: { type: Lightning.shaders.RoundedRectangle, radius: CATEGORY_ITEM_H / 2 }
            },
            Label: {
                x: (w) => w / 2,
                y: 16,
                mountX: 0.5,
                text: {
                    text: "",
                    fontFace: "Regular",
                    fontSize: 24,
                    textColor: Colors(theme.colors.text.primary).get(),
                    maxLines: 1,
                    textOverflow: "ellipsis",
                    textAlign: "center",
                    wordWrapWidth: CATEGORY_ITEM_W - PADDING_X * 2
                }
            },
            FocusLine: {
                y: -1,
                x: -2,
                w: CATEGORY_ITEM_W + 2,
                h: CATEGORY_ITEM_H + 2,
                alpha: 0,
                texture: Lightning.Tools.getRoundRect(
                    CATEGORY_ITEM_W,
                    CATEGORY_ITEM_H,
                    CATEGORY_ITEM_H / 2,
                    2,
                    Colors(theme.colors.focus).get(),
                    false
                )
            }
        };
    }

    set item(value: { name: string }) {
        this._name = value.name;
        this.patch({
            Label: { text: { text: value.name } }
        });
    }

    get name() {
        return this._name;
    }

    set selected(value: boolean) {
        this._selected = value;
        if (!this._isFocused) {
            this.patch({ FocusLine: { smooth: { alpha: value ? 1 : 0 } } });
        }
    }

    override _focus() {
        this._isFocused = true;
        this.patch({
            Bg: {
                smooth: { color: Colors(theme.colors.focus).get() }
            },
            FocusLine: {
                smooth: { alpha: 0 }
            }
        });
    }

    override _unfocus() {
        this._isFocused = false;
        this.patch({
            Bg: {
                smooth: { color: Colors(theme.colors.bg.secondary).get() }
            },
            FocusLine: {
                smooth: { alpha: this._selected ? 1 : 0 }
            }
        });
    }

    override _handleEnter() {
        this.fireAncestors("$onCategorySelected", this._name);
    }
}
